
/* eslint-disable */

import Vue from "vue";
import { PersonService } from "@/services/PersonService";
import PersonRegistrationRequest from "@/models/api/person/PersonRegistrationRequest";
import VuetifyFormMethods from "@/models/vuetify-form-methods";
import { AxiosError } from "axios";
import SelectListItem from "@/models/SelectListItem";
import Person from "../../models/api/person/Person";
import DeleteDialog from '@/components/dialogs/DeleteDialog.vue';
import { DataTableHelper } from '@/helpers/DataTableHelper';
import { SnackbarService } from "@/services/SnackbarService";
import { SettingService } from '../../services/SettingService';
import  ApplicationSettingDto  from '../../models/api/ApplicationSetting';
import { ApplicationSetting, AssociationRoleEnum, ImportPersonStatus} from '../../models/Enums';
import { Gender } from '../../models/Enums';
import { ValidationHelper } from '@/helpers/ValidationHelper';
import IsDirtyHandler from '@/components/ui/IsDirtyHandler';
import { UserService } from '@/services/UserService';
import adaptSSN from '../../helpers/functions/AdaptSSN';
import adaptZipCode from '../../helpers/functions/AdaptZipCode';
import { validateSSNDate, validateDateOfBirth, validateSSN } from '../../helpers/functions/ValidateSSN';
import validateSSNSetting from '../../helpers/functions/ValidateSSNSetting';

export default IsDirtyHandler.extend({
        components: {
        DeleteDialog       
        },
  data() {
        return {
            search: '',
            pageHeader: this.$vuetify.lang.t('$vuetify.person.pageHeader'),
            totalCount: 0,
            items: [],
            loading: true,
            options: {},
            headers: [
               {
                    text: "", sortable: false, align: 'center', value: "hasMandatoryData",
                    width: '1%',
                    class: 'slimDataTableColumnPaddingLeft',
                    cellClass: 'slimDataTableColumnPaddingLeft',
                },
                {
                    text: 'person.firstName',
                    value: 'firstName',
                    align: 'start',                   
                },
                {
                    text: 'person.lastName',
                    value: 'lastName',
                    sortable: true,                 

                },
                {
                    text: 'person.socialSecurityNumber',
                    value: 'socialSecurityNumber',
                    sortable: true,                  
                },
              
                {
                    text: 'person.email',
                    value: 'email',
                    sortable: true,                   
                },
                {
                    text: 'person.mobile',
                    value: 'mobile',
                    sortable: true,                   
                },
                {
                    text: 'person.address',
                    value: 'address',
                    sortable: true,
                },
                {
                    text: 'person.zipCode',
                    value: 'zipCode',
                    sortable: true,                   
                },
                {
                    text: 'person.city',
                    value: 'city',
                    sortable: true,                   
                },
                {
                    text: 'person.role',
                    value: 'role',
                    sortable: true,
                },
                {
                    text: 'person.loginVerified',
                    //sortable: false,
                    value: 'associationRole',
                    align: 'center',
                },               
                {
                    text: "",
                    value: "actions",
                    sortable: false,                   
                    align: 'end'
                },
            ],
                        

            dialogOpen: false,              
            registerPersonFormValid: false,        

            //persons: new Array<Person>(),

            //email: "",           
            //mobile: "",
            //zipCode: "",
            //city: "",
            genders: [{ text: this.$vuetify.lang.t('$vuetify.female'), value: 1 }, { text: this.$vuetify.lang.t('$vuetify.male'), value: 2 }],
            selectedGender: "0",
            genderId: null as Gender | null,     
            //socialSecurityNumber: "",
            //firstName: "",
            //lastName: "",            

            rules: {
                required: (value: any) => !!value || this.$vuetify.lang.t('$vuetify.required'),
                //empty email ok
                email: (value: any) => !value
                    || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
                    || this.$vuetify.lang.t('$vuetify.invalidEmail'),
                //empty zipcode ok
                zipCode: (value: any) => !value || /^\d{3}\s*\d{2}$/.test(value) || this.$vuetify.lang.t('$vuetify.invalidZipCode'),              
                ssnFormat: (value: any) => !value || /^\d{4}\d{2}\d{2}-\d{4}$/.test(value) || this.$vuetify.lang.t('$vuetify.formatSSN'),
                validateSSNDate: (value: any) => validateSSNDate(value) || this.$vuetify.lang.t('$vuetify.person.invalidDate'),
                filerequired: (value: any) => !!value || '' 
               
            },

            settings: new Array<ApplicationSettingDto>(),
            isSSNMandatory: false,
            showGenderSelect: false,
            formatDateOfBirth: "",
            showZipCode: false,
            showCity: false,

            showDeleteDialog: false,
            itemToDeleteId: "",
            itemToDeleteName: "",

            personRequest: {} as Person,       
            associationRole: null as AssociationRoleEnum | null,
            oldEmail: "",
            oldAssociationRole: null as AssociationRoleEnum | null,
            showEmailWillBeUpdatedInformation: false,

            groups: [] as SelectListItem[],
            groupSearchText: null as string | null,
            groupIds: [],

            showGroupDrp: false,

            dialogImportOpen: false,
            importFormValid: false,

            chosenFile: null,
            file: null,

            importedTotalCount: 0,
            importedItems: [],
            selected: [],
            importedHeaders: [
                {
                    text: 'person.firstName',
                    value: 'firstName',
                    align: 'start',                 
                },
                {
                    text: 'person.lastName',
                    value: 'lastName',
                    sortable: false,   
                },
                {
                    text: 'person.socialSecurityNumber',
                    value: 'socialSecurityNumber',
                    sortable: false,                   
                },
                {
                    text: 'person.email',
                    value: 'email',
                    sortable: false,
                },
                {
                    text: 'person.mobile',
                    value: 'mobile',
                    sortable: false,
                },
                {
                    text: 'person.address',
                    value: 'address',
                    sortable: false,
                },
                {
                    text: 'person.zipCode',                   
                    value: 'zipCode',
                    sortable: false,
                },
                {
                    text: 'person.city',                    
                    value: 'city',
                    sortable: false,
                },
                {
                    text: 'importPersons.importPersonStatus',                  
                    value: 'importPersonStatus',
                    sortable: false,
                },
                {
                    text: 'person.isDisabled',
                    value: "isDisabled",
                    sortable: false,
                },
                
            ],
            phoneRules: [
                (v: any) => /^((\+\d{1,3}\s*[0-9]{1,3})|(0[0-9]{1,3}))-*\s*(\d{3,4})\s*(\d{2,3})\s*(\d{1,3})*$/.test(v) || v == null || v == "" || this.$vuetify.lang.t('$vuetify.person.invalidPhoneNumber'),
            ],
         
    };
  },
    created() {
        DataTableHelper.adaptTableHeaders(this.headers, this);
        DataTableHelper.adaptTableHeaders(this.importedHeaders, this);
        //this.getPersonsPaged();
        this.getSettingsByKeyName();
        this.getAssociationUserGroups();

  },
  watch: {
    dialogOpen: {
      handler(open: boolean) {
        if (!open) {
          (this.$refs.personForm as VuetifyFormMethods).reset();
        }
      },
    },
  
      dialogImportOpen: {          
          handler(open: boolean) {             
              if (!open) {
                  (this.$refs.importForm as VuetifyFormMethods).reset();
              }
              else { 
                  this.importedItems = [];
                  this.selected = [];
              }
          },
      },
      search: {
          handler() {
              this.getPersonsPaged();
          },
          deep: true,
      },
      options: {
          handler() {
              this.getPersonsPaged();
          },
          deep: true,
      },
      // Is dirty handling for person edit
      personRequest: {
          handler(change: any) {              
              this.isDirtyChangeTracker(change);
             /* console.log(JSON.stringify(change)) ;*/
          },
          deep: true,
      }
  },
    methods: {
        getValidationRules(): any[] {
            setTimeout(() => (this.$refs.personForm as VuetifyFormMethods)?.validate());
            if (this.isSSNMandatory && !this.personRequest.hasNoSwedishSsn) {
                return [this.rules.validateSSNDate, this.validateSSNSettings, this.checkValidSSN, this.rules.required, this.rules.ssnFormat];
            }
            return [this.rules.validateSSNDate, this.validateSSNSettings, this.checkValidSSN, this.rules.required, this.validDateOfBirth];
        },
        validateSSNSettings(v: any): boolean | string {
            return validateSSNSetting(v, this.isSSNMandatory && !this.personRequest.hasNoSwedishSsn, this.formatDateOfBirth) || this.$vuetify.lang.t('$vuetify.invalidSSN');
        },
        fixSSN() {
            this.personRequest.socialSecurityNumber = adaptSSN(this.personRequest.socialSecurityNumber);
        },
        fixZipCode() {
            this.personRequest.zipCode = adaptZipCode(this.personRequest.zipCode);
        },
        getRoleText(role: AssociationRoleEnum) {
            return AssociationRoleEnum[role];
        },
        changeEmail(newEmail: any) {

 
            if ((this.oldAssociationRole == AssociationRoleEnum.AssociationAdmin || this.oldAssociationRole == AssociationRoleEnum.AssociationGroupAdmin) && this.oldEmail != "" && this.oldEmail != newEmail) {
                this.showEmailWillBeUpdatedInformation = true;
            }
            else {
                this.showEmailWillBeUpdatedInformation = false;
            }          
        },
        changeRole: function (role: any) {
            if (role == "2")
                this.showGroupDrp = true;            
            else
                this.showGroupDrp = false;
        },
        preparePersonEdit(item: Person): void {
        

            // Keeps row in datatable the same, whilst updating the values.
            this.$store.commit('addOverlay');
            PersonService.GetPerson(item.id).then(response => {
                this.personRequest = response.data;
                this.oldEmail = this.personRequest.email;
                this.oldAssociationRole = this.personRequest.associationRole;
                this.showEmailWillBeUpdatedInformation = false;
                this.showGroupDrp = this.personRequest.associationRole == 2 ? true : false;
            }).catch((error) => {
                SnackbarService.addErrorMessage(
                    error.response?.data || error.response?.statusText
                );
            })
            .finally(() => {
                this.$store.commit('removeOverlay');
            });
                       
        },
        closeDialog() {
          
            if (this.isDirtyCheck()) {               
                this.dialogOpen = false;
                this.personRequest = {} as Person;
            }
        },
        getApplicationSetting(app: ApplicationSetting) {
            return this.settings.findIndex((val: any) => val.keyName == app);
        },
     
        async removePerson(id: number) {
            this.showDeleteDialog = false;
          
            if (id != null) { 

                PersonService.RemovePerson(id).then(
                    (result) => {
                        SnackbarService.addSuccessMessage(result?.data);
                        this.getPersonsPaged();
                    },
                    (error) => {                
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            }
        },
        async savePerson(itemToUpdate: Person) {
                      
            const confirmEmailUrl = window.location.href.substr(0, window.location.href.lastIndexOf("#") + 1) + "/confirmUser";

            if (itemToUpdate.id == null || itemToUpdate.id == 0 ) {              

                PersonService.RegisterPerson(new PersonRegistrationRequest(itemToUpdate.firstName, itemToUpdate.lastName, itemToUpdate.socialSecurityNumber, itemToUpdate.email, itemToUpdate.mobile, itemToUpdate.zipCode, itemToUpdate.city, itemToUpdate.address , itemToUpdate.genderId, itemToUpdate.associationRole, itemToUpdate.groupIds, itemToUpdate.isDisabled ?? false, itemToUpdate.hasNoSwedishSsn ?? false), confirmEmailUrl).then(
                    (result) => {
                        // Show success message
                        this.getPersonsPaged();
                        this.dialogOpen = false;
                        this.personRequest = {} as Person;
                        SnackbarService.addSuccessMessage(result?.data, true);
                    },
                    (error: AxiosError) => {

                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            }
            else { 

                PersonService.EditPerson(itemToUpdate, confirmEmailUrl).then((result) => {

                    SnackbarService.addSuccessMessage(result?.data, true);
                    this.getPersonsPaged();
                    this.dialogOpen = false;
                    this.personRequest = {} as Person;
                },
                    (error: AxiosError) => {

                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            }
        },
        async getPersonsPaged() {
            this.loading = true;

            const sortBy = (this.options as any).sortBy ?? [];
            const sortDesc = (this.options as any).sortDesc ?? [];
            const page = (this.options as any).page ?? 1;
            const itemsPerPage = (this.options as any).itemsPerPage ?? 10;

            const data = {
                sortBy: sortBy,
                sortDesc: sortDesc,
                page: page,
                itemsPerPage: itemsPerPage,
                searchText: this.search
            };

            PersonService.GetPersonsPaged(data).then(response => {

                this.totalCount = response.data.totalCount;
                this.items = response.data.items;

            }).catch((error) => {
                SnackbarService.addErrorMessage(
                    error.response?.data || error.response?.statusText
                );
            }).finally(() => {
                this.loading = false;
            });
        },
        async getAssociationUserGroups() {
            this.groups = (await PersonService.GetAssociationsGroupsSelectListItems()).data;

        },

        async getSettingsByKeyName() {

            SettingService.GetSettingsByKeyNames("IsSSNMandatory,FormatOfDateOfBirth, ZipCodeVisibleAndMandatory,CityVisibleAndMandatory")
                .then(response => {
                    this.settings = response.data;

                    this.isSSNMandatory = JSON.parse(this.settings[this.getApplicationSetting(ApplicationSetting.IsSSNMandatory)].value.toString().toLowerCase());
                    this.formatDateOfBirth = this.settings[this.getApplicationSetting(ApplicationSetting.FormatOfDateOfBirth)].value.toString();
                    this.showZipCode = JSON.parse(this.settings[this.getApplicationSetting(ApplicationSetting.ZipCodeVisibleAndMandatory)].value.toString().toLowerCase());
                    this.showCity = JSON.parse(this.settings[this.getApplicationSetting(ApplicationSetting.CityVisibleAndMandatory)].value.toString().toLowerCase());
                    this.showGenderSelect = this.isSSNMandatory ? false : true;
                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                }).finally(() => {
                    this.loading = false;
                    this.$store.commit('removeOverlay');
                });

        },

        async insertOrUpdateFromImport() {
   
           
            //for (var index in this.selected) {
            //    console.log(this.selected[index]);
            //}
          //  console.log(this.selected.length);
            this.$store.commit('addOverlay');
            if (this.selected.length <= 0)             
                SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.importPersons.NoPersonsSelected'));
            else { 
                PersonService.HandleImport(this.selected).then((result) => {

                    SnackbarService.addSuccessMessage(result?.data,true);
                    this.getPersonsPaged();                   
                    this.dialogImportOpen = false;                 
                }).catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                })
                .finally(() => {
                    this.$store.commit('removeOverlay');
                });
            }
        },

        importFile() {          

            if (!this.chosenFile) { //NoFileUploaded
                SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.importPersons.NoFileUploaded'));
            }          

            let formData = new FormData();
   
            formData.append('file', this.chosenFile!);
            this.loading = true;
            PersonService.GetPersonsFromFile(formData).then(response => {              
                //persons that already exists and nothing changed should not be selectable
                //persons with invalid socialsecuritynumber in file should not be selectable
                //persons with associationusers where email has changed should not be selectable
           
                this.importedItems = response.data.items;
                this.importedItems.forEach((s: any) => s.isSelectable = this.isPersonSelectable(s.importPersonStatus));              
                
            }).catch((error) => {
                SnackbarService.addErrorMessage(
                    error.response?.data || error.response?.statusText
                );
            }).finally(() => {
                this.loading = false;
            });

        },

        isPersonSelectable(personStatus: number): boolean {
            return personStatus <= 2;
        },

        getImportPersonStatusName(val: ImportPersonStatus) {
            return this.$vuetify.lang.t('$vuetify.importPersonStatus.' + ImportPersonStatus[val]);        
        },     


        async sendConfirmEmail(email: string) {
      
            const confirmEmailUrl = window.location.href.substr(0, window.location.href.lastIndexOf("#") + 1) + "/confirmUser";

            this.$store.commit('addOverlay');

            UserService.SendConfirmEmail({ email: email, emailConfirmationUrl: confirmEmailUrl }).then(() => {
                SnackbarService.addSuccessMessage(this.$vuetify.lang.t('$vuetify.user.confirmEmailSent'));
            }).catch((error) => {
                if (error.response.data.errors) {
                    SnackbarService.addErrorMessage(error.response.data.errors.join("\n"));
                } else {
                    SnackbarService.addErrorMessage(this.$vuetify.lang.t('$vuetify.generalErrorMessage'));
                }
            }).finally(() => {
                this.$store.commit('removeOverlay');
            });
        },

        // rules
        validDateOfBirth(value: string): string | boolean {
            return validateDateOfBirth(value, this.formatDateOfBirth) || this.$vuetify.lang.t('$vuetify.person.invalidDate');
        },
        // rules

    /* Not to be used before getPersons() is fixed to not fetch all persons full info and called on created!!!
        async getPersons() {
            this.persons = (await PersonService.GetPersons()).data;

        },
        uniqueSocialSecurityNumber(value: string): string | boolean {
            // Filter except from the item being edited.
    
            if (
                value &&
                this.persons
                    .filter((x) => x.id != this.personRequest.id)
                    .findIndex(
                        (f) =>
                            f.socialSecurityNumber.trim().toLocaleLowerCase() ==
                            value.trim().toLocaleLowerCase()
                    ) > -1
            ) {    
               return this.$vuetify.lang.t('$vuetify.person.SSNAlreadyExists') + " " +value;             
            }

            return true;
        },
        */

        checkValidSSN(value: string): string | boolean {
            return validateSSN(value) || this.$vuetify.lang.t('$vuetify.invalidSSN');
        },
    }
});
